import { render, staticRenderFns } from "./DestinationAbattoir.vue?vue&type=template&id=7a29fb65"
import script from "./DestinationAbattoir.vue?vue&type=script&lang=ts"
export * from "./DestinationAbattoir.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports